<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', {'client':contact.client_id})">{{ contact.client.nazwa_pelna}}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('contacts.edit', {'client':contact.client_id, 'contact':contact.id})">{{ contact.email }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Wysłane
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-3 pb-4">Typ</th>
          <th class="px-3 pt-3 pb-4">Data wysyłki</th>
          <th class="px-3 pt-3 pb-4">Podgląd</th>
        </tr>
        <tr v-for="notification in contact.contact_notifications" :key="notification.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="px-3 py-2 flex items-center" tabindex="-1">
              {{ notification.typ.name_pl }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ notification.created_at.replace('T', ' ').substring(0, 19) }}
            </span>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.preview', {'notification':notification.id})">
              <fa icon="eye" size="lg" fixed-width />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="contact.contact_notifications.length === 0">
          <td class="border-t px-3 py-2" colspan="3">Brak wysłanych wiadomości z systemu.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'

export default {
  metaInfo: { title: 'Skrzynka pocztowa - wysłane do klienta' },
  components: {
    Icon
  },
  layout: Layout,
  props: {
    contact: Object,
  },
  data() {
    return {
    }
  },
  // watch: {
  //   form: {
  //     deep: true,
  //     handler: throttle(function() {
  //       this.$inertia.get(this.route('contacts'), pickBy(this.form), { preserveState: true })
  //     }, 150),
  //   },
  // },
  // methods: {
  //   reset() {
  //     this.form = mapValues(this.form, () => null)
  //   },
  // },

  mounted() {
    // console.log(this.contact)
  }
}
</script>
